import { TextField } from "@similarweb/ui-components/forms";
import { Text } from "@similarweb/ui-components/foundations";

import { translate } from "app/filters/i18nFilter";
import { LLMSetupSectionHeader } from "app/pages/digital-marketing/generative-ai/llm-tracker/homepage/components/LLMSetupSectionHeader";
import { PromptsCounter } from "app/pages/digital-marketing/generative-ai/llm-tracker/shared/components/PromptsCounter";

import { PromptsInputWrapper } from "./TopicsSection.styled";

interface IPromptsPerTopicSectionProps {
    value: number;
    selectedTopicsCount: number;
    onChange: (promptsPerTopic: number) => void;
    isDisabled?: boolean;
    isLoading?: boolean;
}

export const PromptsPerTopicSection = ({
    value,
    selectedTopicsCount,
    onChange,
    isDisabled,
    isLoading,
}: IPromptsPerTopicSectionProps) => {
    const onFieldChange = (fieldValue: string): void => {
        const cleanValue = fieldValue.replace(/\D+/g, "");
        const numericValue = cleanValue ? Number(cleanValue) : 0;
        onChange(numericValue);
    };

    return (
        <PromptsInputWrapper>
            <LLMSetupSectionHeader
                title={
                    <Text
                        fontVariant="subtitle2"
                        data-automation="llm-setup-prompts-per-topics-title"
                    >
                        {translate("llm.setup.prompts-per-topic.title")}
                    </Text>
                }
                tooltip={translate("llm.setup.prompts-per-topic.tooltip")}
                titleChildren={
                    <PromptsCounter
                        totalPrompts={value * selectedTopicsCount}
                        isLoading={isLoading}
                    />
                }
            />
            <TextField
                value={value.toString()}
                onChange={onFieldChange}
                isDisabled={isDisabled}
                data-automation="llm-setup-prompts-per-topic-input"
            />
        </PromptsInputWrapper>
    );
};
